import { jwtDecode } from 'jwt-decode';
import { localStorageKeys } from './constants';

/** Access token from `TOKEN` key or nested `loginInfo.token`. */
export function getStoredAccessToken() {
  const { TOKEN, LOGIN_INFO } = localStorageKeys;
  const direct = localStorage.getItem(TOKEN);
  if (direct) return direct;
  try {
    const raw = localStorage.getItem(LOGIN_INFO);
    if (!raw) return null;
    const info = JSON.parse(raw);
    return info?.token || null;
  } catch {
    return null;
  }
}

/**
 * Builds POST /OnLoadRegBranchInformation body from `loginInfo` and/or JWT.
 * Matches backend normalization: trim + lowercase for branchName and team_user_id.
 * @returns {{ branchName: string, team_user_id: string } | null}
 */
export function getOnLoadRegBranchPayloadFromStorage() {
  const { LOGIN_INFO, TOKEN } = localStorageKeys;
  let branchName;
  let team_user_id;
  let token;

  try {
    const raw = localStorage.getItem(LOGIN_INFO);
    if (raw) {
      const info = JSON.parse(raw);
      branchName = info.branchName;
      team_user_id = info.team_user_id ?? info.teamUserId;
      token = info.token;
    }
    token = token || getStoredAccessToken();
    if ((branchName == null || branchName === '' || team_user_id == null || team_user_id === '') && token) {
      const decoded = jwtDecode(token);
      branchName = branchName || decoded.branchName;
      team_user_id = team_user_id ?? decoded.team_user_id;
    }
  } catch (e) {
    console.log('error in getOnLoadRegBranchPayloadFromStorage', e);
    return null;
  }
  console.log('branchName', branchName,team_user_id);
  if (branchName == null) return null;
  const bn = String(branchName).trim().toLowerCase();
  const tid = String(team_user_id ?? '').trim().toLowerCase();
  if (!bn ) return null;
  return { branchName: bn, team_user_id: tid };
  
}
